import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useEntryTarget } from "@/hooks/useUserSystems";

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const { data: entryTarget, isLoading: entryLoading } = useEntryTarget(user?.id);
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Prevent multiple redirects
    if (hasRedirected.current) return;
    
    const currentPath = location.pathname;
    
    if (!loading && !user) {
      // User not authenticated, redirect to login only if not already there
      if (currentPath !== '/login') {
        hasRedirected.current = true;
        navigate('/login', { replace: true });
      }
      return;
    }

    if (user && entryTarget && !entryLoading) {
      // Handle redirection based on entry target
      let targetPath = entryTarget?.basePath || '/';
      
      // Se não tem acesso OU path inválido, redirecionar para /no-access
      if (!entryTarget?.hasAccess || !targetPath || targetPath === '/') {
        targetPath = '/no-access';
      }
      
      // If it's a company system path, redirect to UserArea instead
      if (targetPath && targetPath.includes('/company/') && targetPath.includes('/systems/')) {
        const slugMatch = targetPath.match(/\/company\/([^\/]+)\//);
        if (slugMatch) {
          targetPath = `/company/${slugMatch[1]}/user`;
        }
      }
      
      // Only navigate if we're not already at the target path
      if (currentPath !== targetPath) {
        console.log('Dashboard redirecting from', currentPath, 'to', targetPath);
        hasRedirected.current = true;
        navigate(targetPath, { replace: true });
      }
    }
  }, [user, loading, entryTarget, entryLoading, location.pathname]);

  // Show loading while determining redirect
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p>Redirecionando...</p>
      </div>
    </div>
  );
}